export default class SituacoesVendedor {
  constructor(id = "", situacao = "") {
    this.Id = id
    this.Situacao = situacao
  }
}
